import React, { ReactElement, useState } from "react";
import styles from "./TradeTitle.module.scss";
import { QuoteDisplayFromQuery } from "components/Quotes/QuoteDisplay";
import { HookQueryResult } from "source/hooks";
import { GetIexQuoteQuery } from "$gql/queries/currentPricing/GetIexQuote.gen";
import PerformanceGraph from "components/PerformanceGraph/PerformanceGraph";
import classNames from "classnames";

interface Props {
  companyName: string;
  priceQuery: HookQueryResult<GetIexQuoteQuery, any>;
  tickerSymbol: string;
}

export default function TradeTitle(props: Props): ReactElement {
  const [graphIsInline, setGraphIsInline] = useState(true);
  return (
    <div className={styles.tradeTitle}>
      <h3 className={styles.title}>{props.companyName}</h3>
      <div
        className={classNames(
          styles.tradeTitleContainer,
          !graphIsInline && styles.flexColumn
        )}
      >
        <div className={styles.container}>
          <QuoteDisplayFromQuery
            options={{ displayFormat: "medium", hideMarketCap: true }}
            query={props.priceQuery}
          />
        </div>
        <div
          className={classNames(
            styles.container,
            !graphIsInline && styles.fullWidthContainer
          )}
        >
          <PerformanceGraph
            tickerSymbol={props.tickerSymbol}
            inline
            inlineSwitchCallback={(newValue) => setGraphIsInline(newValue)}
          />
        </div>
      </div>
    </div>
  );
}
